import DatePicker from "@components/DatePicker";
import { ErrorMessage, RadioCard } from "@justhome/react-ui";
import { employmentTypes } from "@lib/options";
import { QualificationFormData } from "@modules/booking/context/types";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { Controller, useForm } from "react-hook-form";
import { Form, FormField, FormRow } from "../Form";
import FormSection from "../FormSection";
type EmploymentFormValues = Pick<QualificationFormData, "employmentType" | "employedSince">;
interface EmploymentFormProps {
  onSubmit: (data: EmploymentFormValues) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const EmploymentForm = ({
  onSubmit,
  canGoBack,
  onGoBack,
  isLoading,
  isError
}: EmploymentFormProps) => {
  const {
    t
  } = useBookingTranslation();
  const {
    register,
    handleSubmit,
    formState: {
      errors
    },
    watch,
    control
  } = useForm<EmploymentFormValues>({});
  const formId = "employment-form";
  const employmentType = watch("employmentType");
  const showEmployedSince = employmentType === "SELF_EMPLOYED" || employmentType === "FREELANCER";
  return <FormSection formId={formId} canGoBack={canGoBack} onGoBack={onGoBack} isLoading={isLoading} isError={isError}>
      <Form id={formId} onSubmit={handleSubmit(onSubmit)}>
        <FormRow>
          <FormField>
            <label htmlFor="employmentType" className="block text-title-1 mb-xs">
              {t("employmentForm.employmentTypeLabel")}
            </label>
            <div className="grid m:grid-cols-2 gap-3xs">
              {employmentTypes.map(employmentType_0 => <RadioCard key={employmentType_0} value={employmentType_0} type="radio" size="sm" {...register("employmentType", {
              required: t("employmentForm.employmentTypeRequiredError")
            })}>
                  {t(`employmentTypes.${employmentType_0}`)}
                </RadioCard>)}
            </div>
            {errors.employmentType && <ErrorMessage>{errors.employmentType?.message}</ErrorMessage>}
          </FormField>
        </FormRow>
        {showEmployedSince && <FormField>
            <Controller name="employedSince" control={control} rules={{
          required: t("employmentForm.errorRequiredEmployedSince")
        }} render={({
          field
        }) => <DatePicker label={t("employmentForm.labelEmployedSince")} value={field.value || undefined} onChange={field.onChange} onBlur={field.onBlur} placeholder="TT.MM.JJJJ" errorMessage={errors.employedSince?.message} maxDate={new Date()} />} />
          </FormField>}
      </Form>
    </FormSection>;
};
export default EmploymentForm;